(() => {
  if (window.kindraEnquirySubscriptionInitialized || window.Shopify?.designMode) return;
  const config = document.querySelector('[data-kindra-enquiry-config]');
  const template = document.querySelector('template[data-enquiry-subscription]');
  const signup = template?.content.querySelector('form');
  if (!config || !signup) return;
  window.kindraEnquirySubscriptionInitialized = true;
  const preview = config.dataset.preview === 'true' || window.Shopify?.theme?.role !== 'main';
  const environment = preview ? 'draft' : 'live';
  const key = `kindra.enquiry.signup.v2.${environment}`;
  const maxAge = 30 * 60 * 1000;
  let starting = false;
  const clear = () => { try { sessionStorage.removeItem(key); } catch {} };
  const save = record => { try { sessionStorage.setItem(key, JSON.stringify(record)); return true; } catch { return false; } };
  try { sessionStorage.removeItem(`kindra.enquiry.signup.v1.${environment}`); } catch {}
  function read() {
    try {
      const record = JSON.parse(sessionStorage.getItem(key));
      if (!record) return null;
      if (!record.created || Date.now() - record.created > maxAge || record.created > Date.now() || !['contact', 'delivery_quote', 'purchase_enquiry'].includes(record.type)) { clear(); return null; }
      return record;
    } catch { return null; }
  }
  function localURL(path) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid enquiry destination');
    return url;
  }
  const relative = url => url.pathname + url.search + url.hash;
  function confirmed(record) {
    if (record.phase !== 'pending' || !record.email || !record.formId) return false;
    const finish = localURL(record.finish);
    const current = new URL(location.href);
    if (current.pathname !== finish.pathname || current.hash !== '#' + record.formId || current.searchParams.get('contact_posted') !== 'true') return false;
    if (finish.searchParams.has('variant') && current.searchParams.get('variant') !== finish.searchParams.get('variant')) return false;
    const marker = Array.from(document.querySelectorAll('[data-kindra-enquiry]')).find(el => el.closest('form')?.id === record.formId);
    if (marker?.dataset.errors === 'true') return false;
    if (record.type === 'contact') return current.pathname === localURL(config.dataset.contactSuccessUrl).pathname;
    return marker?.dataset.success === 'true';
  }
  function outcome(record, status) {
    const result = { created: record.created, token: record.token, type: record.type, formId: record.formId, phase: status };
    save(result);
    document.dispatchEvent(new CustomEvent('kindra:enquiry-subscription-result', { detail: { enquiry_type: record.type, status, environment } }));
  }
  async function start(record) {
    if (starting) return;
    starting = true;
    const attempted = { created: record.created, token: record.token, type: record.type, formId: record.formId, phase: 'attempted' };
    if (!save(attempted)) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const action = localURL(signup.getAttribute('action'));
      action.hash = '';
      const body = new FormData(signup);
      const [first = '', ...last] = record.name.trim().split(/\s+/);
      body.set('contact[email]', record.email);
      body.set('contact[first_name]', first);
      body.set('contact[last_name]', last.join(' '));
      body.set('contact[tags]', `kindra-enquiry,kindra-informational-follow-up,kindra-consent-v1,kindra-enquiry-${record.type.replace('_', '-')}`);
      const destination = localURL(record.finish);
      destination.searchParams.delete('contact_posted');
      destination.searchParams.set('kindra_enquiry_signup', record.token);
      destination.hash = signup.id;
      body.set('return_to', relative(destination));
      const response = await fetch(action.href, { method: 'POST', body, credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) { outcome(record, 'unconfirmed'); return; }
      const returned = localURL(response.url);
      if (returned.pathname !== destination.pathname || returned.searchParams.get('kindra_enquiry_signup') !== record.token) { outcome(record, 'unconfirmed'); return; }
      const result = new DOMParser().parseFromString(await response.text(), 'text/html')
        .querySelector('template[data-enquiry-subscription]')?.content.querySelector('[data-enquiry-subscription-result]');
      const accepted = result?.dataset.success === 'true' && result.dataset.errors === 'false';
      outcome(record, accepted ? 'accepted' : 'unconfirmed');
    } catch {
      outcome(record, 'unconfirmed');
    } finally {
      clearTimeout(timeout);
    }
  }
  function init() {
    const record = read();
    if (!record) return;
    try { if (confirmed(record)) void start(record); } catch { clear(); }
  }
  function bind() {
    document.querySelectorAll('[data-kindra-enquiry]').forEach(marker => {
      const form = marker.closest('form');
      if (!form || form.dataset.enquirySignupBound) return;
      form.dataset.enquirySignupBound = 'true';
      form.addEventListener('formdata', event => {
        if (!form.checkValidity()) return;
        const type = marker.dataset.kindraEnquiry;
        if (!['contact', 'delivery_quote', 'purchase_enquiry'].includes(type)) return;
        const email = event.formData.get('contact[email]')?.trim();
        if (!email) return;
        try {
          const finish = localURL(event.formData.get('return_to') || config.dataset.contactSuccessUrl);
          save({ created: Date.now(), token: crypto.randomUUID(), phase: 'pending', type, formId: form.id, finish: relative(finish), email, name: (event.formData.get('contact[name]') || '').slice(0, 150) });
        } catch {}
      });
    });
  }
  bind();
  init();
  window.addEventListener('pageshow', init);
  document.addEventListener('shopify:section:load', () => { bind(); init(); });
})();

